export default __webpack_public_path__ + "static/Projetistas-312c8a6c6c53bca8a7e37b09ab41a190.jpg";